import { ChecklistTemplateGroup, ChecklistTemplateItem } from '@/types/unlock'

import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface TaskTemplateEditionProps {
  editing: boolean
  type: 'item' | 'group'
  activeItem: null | ChecklistTemplateGroup | ChecklistTemplateItem
}

export interface TaskTemplateFormatFilters {
  group?: string
  search?: string
}

interface TaskTemplateStateType {
  edition: TaskTemplateEditionProps
  filters: TaskTemplateFormatFilters
}

const initialEditionState: TaskTemplateEditionProps = {
  editing: false,
  type: 'item',
  activeItem: null,
}

const initialFormatFiltersState: TaskTemplateFormatFilters = {
  group: '',
  search: '',
}

const initialState: TaskTemplateStateType = {
  edition: initialEditionState,
  filters: initialFormatFiltersState,
}

const taskTemplateSlice = createSlice({
  name: 'taskTemplate',
  initialState,
  reducers: {
    setEdition: (state, action: PayloadAction<TaskTemplateEditionProps>) => {
      state.edition = action.payload
    },
    setFilters: (state, action: PayloadAction<Partial<TaskTemplateFormatFilters>>) => {
      state.filters = { ...state.filters, ...action.payload }
    },
  },
})

export const { setEdition, setFilters } = taskTemplateSlice.actions

export const taskTemplateReducer = taskTemplateSlice.reducer
